<template>
  <div class="newsMain">
    <PcNewsCenterNew class="PC" />
    <MdNewsCenter class="MD" />
  </div>
</template>

<script>
// 移动端
import MdNewsCenter from "./MdNewsCenter2.vue";
// pc端
import PcNewsCenterNew from "./PcNewsCenter4.vue";
// 引入获取新闻类别
import { getArticle } from "@/api/news";
export default {
  name: "newsMain",
  components: {
    // PcNewsCenter,
    MdNewsCenter,
    PcNewsCenterNew
  },
  created() {
    // 调用获取新闻类型
    this.getArticle();
  },
  methods: {
    // 获取新闻类型
    async getArticle() {
      const res = await getArticle();
      // console.log(res)
      if (res.Msg === "获取成功") {
        this.newsTitle = res.Data;
        this.newsTitle.sort((a, b) => {
          return a.ID - b.ID;
        });
        this.$store.commit("getNewsTitle", this.newsTitle);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
// 移动
@media only screen and (max-width: 750px) {
  .newsMain {
    .PC {
      display: none;
    }
  }
}
// PC端/
@media only screen and (min-width: 756px) {
  .newsMain {
    .MD {
      display: none;
    }
  }
}
</style>
